import { useCallback } from 'react';

import {
  TrackPageActionT,
  TrackPageReqT,
} from '@consumer-frontend/nc-utils';

import { sendBeacon } from '../../lib/tracking';

type BeaconTrackingEndpointsT = {
  trackPageUrl: string;
};

type UseBeaconTrackingArgsT = {
  endpoints: BeaconTrackingEndpointsT;
};

type UseBeaconTrackingT<PageAction extends TrackPageActionT> = {
  trackPage: (arg: TrackPageReqT<PageAction>) => void;
};

export const useBeaconTracking = <PageAction extends TrackPageActionT>(
  { endpoints }: UseBeaconTrackingArgsT,
): UseBeaconTrackingT<PageAction> => {
  const trackPage = useCallback(
    (arg: TrackPageReqT<PageAction>): void => {
      sendBeacon(
        endpoints.trackPageUrl,
        arg,
        { failureMessage: 'sendBeacon failed to queue page view' },
      );
    },
    [endpoints.trackPageUrl],
  );

  return { trackPage };
};
